import { type ElementType } from 'react';
import { cn } from '@/lib/cn.js';
import { Card } from './card.js';

type StatTone = 'default' | 'primary' | 'emerald' | 'red' | 'amber' | 'blue';

interface StatCardProps {
  icon?: ElementType;
  label: string;
  value: string | number;
  sub?: string;
  tone?: StatTone;
  className?: string;
}

const TONE_CLS: Record<StatTone, string> = {
  default: 'text-muted-foreground',
  primary: 'text-primary',
  emerald: 'text-emerald-500',
  red: 'text-red-500',
  amber: 'text-amber-500',
  blue: 'text-blue-500',
};

export function StatCard({ icon: Icon, label, value, sub, tone = 'default', className }: StatCardProps): JSX.Element {
  return (
    <Card className={cn('p-5', className)}>
      <div className="flex items-center justify-between">
        <span className="text-sm font-medium text-muted-foreground">{label}</span>
        {Icon && <Icon size={17} className={TONE_CLS[tone]} />}
      </div>
      <div className="mt-2 text-3xl font-bold tracking-tight tabular-nums">{value}</div>
      {sub && <div className="mt-1 text-xs text-muted-foreground">{sub}</div>}
    </Card>
  );
}
